module.exports = __webpack_public_path__ + "static/kdb-banner-2@2x-9e7b0dff11a25dcc38c440bf1698b500.png";